import api from './httpClient';

export const ServiceApi = {
  getAll: () => api.get('/services').then((res) => res.data.data),
  getOne: (identifier) => api.get(`/services/${identifier}`).then((res) => res.data.data),
  create: (payload) => api.post('/services', payload).then((res) => res.data.data),
  update: (id, payload) => api.put(`/services/${id}`, payload).then((res) => res.data.data),
  remove: (id) => api.delete(`/services/${id}`)
};

export const PortfolioApi = {
  getAll: (options = {}) => {
    const params = {};
    if (options.serviceAlias) params.serviceAlias = options.serviceAlias;
    if (options.serviceId) params.serviceId = options.serviceId;
    const config = Object.keys(params).length ? { params } : {};
    return api.get('/portfolios', config).then((res) => res.data.data);
  },
  getBySlug: (slug) => api.get(`/portfolios/slug/${slug}`).then((res) => res.data.data),
  create: (payload) => api.post('/portfolios', payload).then((res) => res.data.data),
  update: (id, payload) => api.put(`/portfolios/${id}`, payload).then((res) => res.data.data),
  remove: (id) => api.delete(`/portfolios/${id}`)
};

export const BlogApi = {
  getAll: (params = {}) => {
    const hasParams = Object.values(params).some((value) => value !== undefined && value !== '');
    const config = hasParams ? { params } : {};
    return api.get('/blogs', config).then((res) => res.data.data);
  },
  getOne: (id) => api.get(`/blogs/${id}`).then((res) => res.data.data),
  getBySlug: (slug) => api.get(`/blogs/slug/${slug}`).then((res) => res.data.data),
  create: (payload) => api.post('/blogs', payload).then((res) => res.data.data),
  update: (id, payload) => api.put(`/blogs/${id}`, payload).then((res) => res.data.data),
  remove: (id) => api.delete(`/blogs/${id}`)
};

export const BlogTopicApi = {
  getAll: () => api.get('/blog-topics').then((res) => res.data.data),
  getOne: (id) => api.get(`/blog-topics/${id}`).then((res) => res.data.data),
  create: (payload) => api.post('/blog-topics', payload).then((res) => res.data.data),
  update: (id, payload) => api.put(`/blog-topics/${id}`, payload).then((res) => res.data.data),
  remove: (id) => api.delete(`/blog-topics/${id}`)
};

export const TestimonialApi = {
  getAll: (pagePath) => {
    const config = pagePath ? { params: { pagePath } } : {};
    return api.get('/testimonials', config).then((res) => res.data.data);
  },
  create: (payload) => api.post('/testimonials', payload).then((res) => res.data.data),
  update: (id, payload) => api.put(`/testimonials/${id}`, payload).then((res) => res.data.data),
  remove: (id) => api.delete(`/testimonials/${id}`)
};

export const UploadApi = {
  uploadImage: (file) => {
    const formData = new FormData();
    formData.append('image', file);
    return api
      .post('/uploads/images', formData)
      .then((res) => res.data);
  }
};

export const ContactQueryApi = {
  submit: (payload) => api.post('/contact-queries', payload).then((res) => res.data.data),
  getAll: (status) => {
    const config = status ? { params: { status } } : {};
    return api.get('/contact-queries', config).then((res) => res.data.data);
  },
  updateStatus: (id, status) => api.patch(`/contact-queries/${id}/status`, { status }).then((res) => res.data.data)
};

export const QuoteRequestApi = {
  submit: (payload) => api.post('/quote-requests', payload).then((res) => res.data.data),
  getAll: (status) => {
    const config = status ? { params: { status } } : {};
    return api.get('/quote-requests', config).then((res) => res.data.data);
  },
  updateStatus: (id, status) => api.patch(`/quote-requests/${id}/status`, { status }).then((res) => res.data.data)
};
